export const phoneRegEx = /^[0-9-+]*$/;
export const nameRegEx = /^[a-z ,.'_-]{2,30}$/i;
export const venderNameRegEx = /^[^-\s][a-zA-Z0-9\s]+$/;
export const usernameRegEx = /^[a-zA-Z0-9-_+$%&*()?@#!.><:;']*$/;
export const emailRegEx = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const onlyAcceptsNumber = /^[0-9]*$/;
export const underscoreRegEx = /^[a-zA-Z0-9-_]+$/;
export const roleNameRegEx = /^[^-\s][a-zA-Z0-9\s]+$/;
export const trailerNumberRegex = /^[A-Z0-9]+$/;
